export default __webpack_public_path__ + "static/media/klientkarya.95e54b84.png";